import { fugitiveDescription } from './pages/fugitiveDescription'
import { fugitiveName } from './pages/fugitiveName'
import { lastKnownLocation } from './pages/lastKnownLocation'
import { fileUploadPage } from '../../../pages/fileUploadPage'
import { contactInfo } from './pages/contactInfo'
import { reviewFugitivePage } from '../../../pages/reviewFugitivePage'
import { InspectFugitive } from '../../../components/Inspect'

export const formSchema = onSubmit => ({
  title: 'Report a fugitive',
  onSubmit,
  pages: [
    fugitiveName,
    lastKnownLocation,
    fugitiveDescription,
    fileUploadPage(),
    contactInfo,
    reviewFugitivePage(InspectFugitive)
  ]
})
